import { Typography } from "@mui/material";
import React from "react";

export function PageHeader({ Title }) {
  return <Typography variant="h2">{Title}</Typography>;
}
